import { Box, styled } from "@mui/material";

export const PureGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 8px;
`;
